import { resetInstrumentation } from "@store/slices/globalState";
import { store } from "@store/store";

export const resetInstrumentationData = () => {
    store?.dispatch(resetInstrumentation({}))
}

